import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

/**
 * HtmlTooltip - Styled tooltip component with custom Material-UI styling
 * Complete migration from front/src/components/HtmlTooltip.js
 *
 * Provides custom styling for tooltips with HTML content support,
 * including custom background color, border, and typography.
 *
 * @param {Object} props - All Tooltip props from Material-UI
 * @param {React.ReactNode} props.title - Tooltip content (can be HTML/JSX)
 * @param {React.ReactNode} props.children - Element that triggers the tooltip
 * @returns {React.ReactElement} Styled tooltip component
 *
 * @example
 * <HtmlTooltip title={<div>HTML content</div>}>
 *   <Button>Hover me</Button>
 * </HtmlTooltip>
 */
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

HtmlTooltip.displayName = 'HtmlTooltip';

export default React.memo(HtmlTooltip);
